<template>
  <layout>
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Documentación</h1>
    </div>
    <div>
      <ul
        class="nav nav-tabs nav-justified md-tabs indigo"
        id="myTabJust"
        role="tablist"
      >
        <li class="nav-item">
          <a
            @click="() => setTab('guias')"
            class="nav-link active"
            id="guias-tab"
            data-toggle="tab"
            href="#guias-tab"
            role="tab"
            aria-controls="guias-tab"
            aria-selected="false"
            style="font-size: 0.9rem"
            >Guías de Transporte</a
          >
        </li>
        <li class="nav-item">
          <a
            @click="() => setTab('otros')"
            class="nav-link"
            id="simplificadas-tab"
            data-toggle="tab"
            href="#simplificadas-tab"
            role="tab"
            aria-controls="simplificadas-tab"
            aria-selected="true"
            style="font-size: 0.9rem"
            >Dest. Simplificada</a
          >
        </li>
        <li class="nav-item">
          <a
            @click="() => setTab('caratulas')"
            class="nav-link"
            id="caratulas-tab"
            data-toggle="tab"
            href="#caratulas-tab"
            role="tab"
            aria-controls="caratulas-tab"
            aria-selected="false"
            style="font-size: 0.9rem"
            >Carátulas</a
          >
        </li>
        <li class="nav-item">
          <a
            @click="() => setTab('facturas')"
            class="nav-link"
            id="facturas-tab"
            data-toggle="tab"
            href="#facturas-tab"
            role="tab"
            aria-controls="facturas-tab"
            aria-selected="false"
            style="font-size: 0.9rem"
            >Facturas</a
          >
        </li>

        <li class="nav-item">
          <a
            @click="() => setTab('recibos')"
            class="nav-link"
            id="recibos-tab"
            data-toggle="tab"
            href="#recibos-tab"
            role="tab"
            aria-controls="recibos-tab"
            aria-selected="false"
            style="font-size: 0.9rem"
            >Recibos</a
          >
        </li>
        <li class="nav-item">
          <a
            @click="() => setTab('guias-madre')"
            class="nav-link"
            id="guias-madre-tab"
            data-toggle="tab"
            href="#guias-madre-tab"
            role="tab"
            aria-controls="guias-madre-tab"
            aria-selected="false"
            style="font-size: 0.9rem"
            >Guías Madre</a
          >
        </li>
        <li class="nav-item">
          <a
            @click="() => setTab('notas-credito')"
            class="nav-link"
            id="notas-credito-tab"
            data-toggle="tab"
            href="#notas-credito-tab"
            role="tab"
            aria-controls="notas-credito-tab"
            aria-selected="false"
            style="font-size: 0.9rem"
            >Notas Credito</a
          >
        </li>
      </ul>
      <div class="tab-content card pt-5" id="myTabJust">
        <div
          class="tab-pane fade show active"
          id="guias-tab"
          role="tabpanel"
          aria-labelledby="guias-tab"
        >
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Archivo</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(document, index) in currentDocuments"
                  :key="document.id+index"
                >
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ getFecha(document) }}</td>
                  <td>{{ getName(document) }}</td>
                  <td>
                    <button
                      type="button"
                      class="btn btn-primary btn-sm"
                      @click="() => openFile(document.link)"
                    >
                      Ver / Descargar Archivo
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="simplificadas-tab"
          role="tabpanel"
          aria-labelledby="simplificadas-tab"
        >
          Tabla 2
        </div>
        <div
          class="tab-pane fade"
          id="facturas-tab"
          role="tabpanel"
          aria-labelledby="facturas-tab"
        >
          Tabla 3
        </div>
        <div
          class="tab-pane fade"
          id="recibos-tab"
          role="tabpanel"
          aria-labelledby="recibos-tab"
        >
          Tabla 4
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
const TABS = {
  guias: "guias",
};
import Layout from "../layout/Layout";
export default {
  data() {
    return {
      currrentTab: TABS.guias,
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    createPDFThumbnails();
  },
  components: { Layout },
  methods: {
    setTab(tab) {
      this.currrentTab = tab;
    },
    getName(file) {
      if (file.id.startsWith("fca")) {
        return file.id.split(".")[0].slice(3, -6);
      } else if (file.id.startsWith("nca")) {
        return file.id.split(".")[0].slice(0, -6);
      } else if (file.id.startsWith("nda")) {
        return file.id.split(".")[0].slice(0, -6);
      } else if (file.id.startsWith("GM")) {
        return file.id.split(".")[0].slice(2, -6);
      }
      return file.id.split(".")[0].slice(2, -6);
    },
    openFile(link) {
      window.open(link, "_blank");
    },
    getFecha(document) {
      return document.date.split("-").join("/");
    },
  },
  computed: {
    documentacion() {
      return this.$store.state.user.documents;
    },
    currentDocuments() {
      console.log("this.documentacion", this.documentacion);
      switch (this.currrentTab) {
        case "guias":
          return this.documentacion.guias;
        case "facturas":
          return this.documentacion.facturas;
        case "otros":
          return this.documentacion.otros;
        case "recibos":
          return this.documentacion.recibos;
        case "caratulas":
          return this.documentacion.caratulas;
        case "guias-madre":
          return this.documentacion.guiasMadre;
        case "notas-credito":
          return this.documentacion.notasCredito;
        default:
          return [];
      }
    },
  },
};
</script>

<style scoped>
.documentation-container {
  display: flex;
  flex-direction: row;
  overflow: scroll;
  box-sizing: border-box;
}
.documentation-container > * {
  box-sizing: border-box;

  flex-shrink: 0;
  margin-right: 12.5px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 12.5px;
}
.empty-documentos {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}
</style>
